export default function X() {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24' fill='none'>
            <path d='M17 7L7 17' stroke='#888888' strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M7 7L17 17' stroke='#888888' strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
}
